export const PresetsInvalidationSymbol = Symbol('PresetsInvalidation')
